import React, { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import LibraryHomePage from "./Library/LibraryHome";
import LibraryPortfolioPage from "./Library/LibraryPortfolio";
import styles from "./Library/Library.module.css";
import { useAppSelector } from "../Redux/Store/Store";
import { getLibraryGen3Enabled } from "../Redux/Store/Slices/client";
import { navigateToLegacyMesma } from "../Data/NavbarData";

const Library = () => {
  const navigate = useNavigate();
  const libraryGen3Enabled = useAppSelector(getLibraryGen3Enabled);

  useEffect(() => {
    if (libraryGen3Enabled === false) {
      navigateToLegacyMesma("/Library");
      navigate("/", { replace: true });
    }
  }, [libraryGen3Enabled, navigate]);

  if (libraryGen3Enabled !== true) {
    return null;
  }

  return (
    <div className={styles.shell}>
      <Routes>
        <Route index element={<LibraryHomePage />} />
        <Route path=":portfolioId" element={<LibraryPortfolioPage />} />
      </Routes>
    </div>
  );
};

export default Library;
